module.exports = __webpack_public_path__ + "media/images/icons/icn_041-e8fb359aa66264285b816ca4d260c655.svg";